/* istanbul ignore file */
import React from 'react';
import { EnumDropdown, DefaultInputPropTypes } from 'framework/form';
import { ASSET_CATEGORIES_OPTIONS } from 'domain/finance/assets/useAssetService';

const AssetCategoryDropdown = (props: DefaultInputPropTypes<string>) => {
  return <EnumDropdown options={ASSET_CATEGORIES_OPTIONS} {...props} />;
};

export default AssetCategoryDropdown;
